<div [ngClass]="{'square flex items-center pl-1.5 pb-1' : !isLogged }">
  <button [matMenuTriggerFor]="langMenu" mat-mini-fab>
    <mat-icon svgIcon="globe" class="action"></mat-icon>
  </button>

  <mat-menu #langMenu="matMenu">
    <button *ngFor="let locale of LOCALES" (click)="changeLocale(locale)" mat-menu-item>{{'main.locale.' + locale | translate}}</button>
  </mat-menu>
</div>
